import type { CuttingSetupRecordV1 } from '@gk/contracts'
import type { OverlayRow } from './db.ts'
import type { Projector } from './projectors.ts'
import { localDate } from '../lib/time.ts'

/** M16-J (docs/M16.md rule 2): the projection of cutting_setup.record@1, a field FACT. The setup shows on this device at once, pending, on the club's own day,
 *  with what was typed (the height and the target as entered, the method, the note trimmed, the job when there was one), until the server's row replaces it.
 *  The id is the device's own (newId), so a retry duplicates nothing; whether the machine is retired is the server's to say (ASSET_NOT_ACTIVE then tells
 *  the person). Registered in projectors.ts under the M16a hook. */
export const cuttingSetupRecord: Projector = async (cmd, db) => {
  const p = cmd.payload as CuttingSetupRecordV1
  const at = p.measured_at ?? cmd.occurred_at
  const tz = ((await db.site.get(cmd.site_id)) as { timezone?: string } | undefined)?.timezone ?? 'Europe/Paris'
  const row: OverlayRow = {
    key: `fleet.cutting_setup:${p.setup_id}`, table: 'fleet.cutting_setup', id: p.setup_id, command_id: cmd.command_id, op: 'insert',
    row: {
      id: p.setup_id, org_id: cmd.org_id, site_id: cmd.site_id, asset_id: p.asset_id, measured_mm: p.measured_mm, target_mm: p.target_mm ?? null, method: p.method,
      measured_at: at, measured_local_date: localDate(at, tz), note: p.note?.trim() || null, job_id: p.job_id ?? null, entered_at: cmd.occurred_at,
      actor_person_id: cmd.actor_person_id ?? null, _pending: true,
    },
  }
  return [row]
}
